// istanbul ignore file

import styled, { css } from 'styled-components';
import CollapsiblePanel, { StyledFloatingPanel } from '@cld/collapsible-panel';
import { lightTheme } from '@clds/themes';

export const SIDE_MENU_WIDTH = '300px';
const SIDE_MENU_PADDING_TOP = lightTheme.spacing.sm;

export const StyledCollapsiblePanel = styled(CollapsiblePanel)`
  background-color: ${(props) => props.theme.palette.surface};
  height: 100%;

  ${StyledFloatingPanel} {
    border-right: solid 1px ${(props) => props.theme.palette.secondaryAlt};
  }

  .collapsible-panel-toggle-button {
    top: calc(${SIDE_MENU_PADDING_TOP});
  }
`;
export const HeaderWrapper = styled.div`
  margin-bottom: ${(props) => props.theme.spacing.sm};
`;

export const StyledSideMenu = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: space-between;
  padding: ${({ noPadding }) => css`
    ${noPadding ? 0 : SIDE_MENU_PADDING_TOP} 0 ${(props) => props.theme.spacing.lg}
  `};
  width: ${SIDE_MENU_WIDTH};
  height: 100%;
  background-color: ${(props) => props.theme.palette.surface};
`;

export const StyledSectionContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSectionTop = styled(StyledSection)`
  flex: 1;
  min-height: 0;
  margin-bottom: ${(props) => props.theme.spacing.xs};
`;

export const HeaderPadding = styled.div`
  padding: 0 ${(props) => props.theme.spacing.sm};
`;
